<div class="w-full h-full">
    <div class="fade h-full w-full">
       <div class="border-b border-gray-300 flex justify-between zuper-dialog-header">
         <div class="primary-font font-bold text-xl text-gray-700 flex items-center pl-2">
             {{'maps.header.setting' | translate}}
         </div>
         <div class="flex justify-around">
             <a class="h-10 w-10 flex justify-center items-center hover:bg-gray-200 rounded-full cursor-pointer" (click)="closeDrawer()">
                 <em class="ti ti-x text-gray-900 text-xl"></em>
             </a>
         </div>
       </div>
         
       <div class="bg-white primary-font p-6 main-settings-container">
          <div class="flex items-center mb-4">
             <input [checked]="settings['overlay_routes']" id="overlay-routes" type="checkbox" (change)="toggleOverlay('overlay_routes')" value="" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded dark:bg-gray-700 dark:border-gray-600">
             <label for="overlay-routes" class="ml-2 text-base font-medium text-gray-900 dark:text-gray-300 cursor-pointer">{{'maps.label.over_routes' | translate}}</label>
         </div>
         <div class="flex items-center">
             <input [checked]="settings['overlay_territories']" id="overlay-territory" type="checkbox" (change)="toggleOverlay('overlay_territories')" value="" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded dark:bg-gray-700 dark:border-gray-600">
             <label for="overlay-territory" class="ml-2 text-base font-medium text-gray-900 dark:text-gray-300 cursor-pointer">{{'maps.label.over_territories' | translate}}</label>
         </div>
       </div>

       <div class="flex justify-end border-t border-gray-300 zuper-dialog-footer space-x-4">
          <button type="button" mat-stroked-button class="px-6 w-24 btn-small items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none" (click)="closeDrawer()">{{'cancel.text' | translate}}</button>
          <button (click)="saveSettings()" type="button" class="w-24 btn-small px-6 flex justify-center items-center py-2 border b-1 border-gray-300 shadow-sm text-white font-medium rounded-md text-white-600 focus:outline-none bg-primary">
            {{'text.save' | translate}}
          </button>
      </div>
     </div>
 </div>